import axios from '@/utils/request'

const currentNew = async (cli) => {
  const { data } = await axios.post('/version/currentNew', { cli })
  return data.data
}

export default { currentNew }
